module.exports = "<fulfillment-plans-page></fulfillment-plans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/fulfillmentPlansView.html
// module id = 2145
// module chunks = 0